// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fA","advertDetailParameterList__header":"c-q_fB","advertDetailParameterList__list":"c-q_fC"};